const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20young%20Chinese%20man%20with%20warm%20smile%2C%20clean%20studio%20lighting%20on%20neutral%20cream%20background%2C%20friendly%20expression%2C%20modern%20casual%20style%2C%20high%20quality%20portrait%20photography&width=120&height=120&seq=comment-avatar-01&orientation=squarish',
    name: '电影发烧友小林',
    text: '自从发现六六影院，追新片再也不用到处找资源了！更新速度超快，画质清晰流畅，周末电影马拉松全靠它，已经推荐给身边所有朋友。',
    tag: '忠实用户',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20clean%20studio%20lighting%20on%20neutral%20cream%20background%2C%20warm%20expression%2C%20modern%20casual%20style%2C%20high%20quality%20portrait%20photography&width=120&height=120&seq=comment-avatar-02&orientation=squarish',
    name: '科幻影迷阿杰',
    text: '作为一个科幻片重度爱好者，六六影院的片库真的让我惊喜！从经典《银翼杀手》到最新科幻大作全都有，分类清晰找片特别方便。',
    tag: '科幻迷',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20middle%20aged%20Chinese%20man%20with%20confident%20expression%2C%20clean%20studio%20lighting%20on%20neutral%20cream%20background%2C%20friendly%20look%2C%20modern%20style%2C%20high%20quality%20portrait%20photography&width=120&height=120&seq=comment-avatar-03&orientation=squarish',
    name: '家庭观众王姐',
    text: '周末一家人窝在沙发上看电影成了我们的固定节目。六六影院喜剧片和动画片特别多，大人小孩都能找到喜欢的，关键是免费画质还好！',
    tag: '家庭用户',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            影迷的真实声音
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            来自六六影院用户的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {comments.map((item) => (
            <div
              key={item.name}
              className="bg-background-100 rounded-2xl p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{item.name}</div>
                  <span className="inline-block mt-0.5 text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="flex items-center gap-1 mt-4 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}